import { RootState } from 'types/root';
import { PrepareAdyenResp, TransactionAdyenState } from 'types/transaction-adyen';

export const transactionsAdyenTree = (state: RootState): TransactionAdyenState => state.transactionAdyen || {};

export const transactionsAdyenLoading = (state: RootState): boolean => transactionsAdyenTree(state).isLoading || false;

export const transactionsAdyenPrepareResp = (state: RootState): PrepareAdyenResp =>
  transactionsAdyenTree(state).prepareAdyenResp || {};

export const transactionsAdyenCCLoading = (state: RootState): boolean =>
  transactionsAdyenTree(state).isAdyenLoading || false;
